module.exports = __webpack_public_path__ + "static/media/banner_2023.78bdac4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/banner_2023.png
// module id = 1050
// module chunks = 0